var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browser-category",class:[ _vm.theme, 'view-' + _vm.view]},[_c('div',{staticClass:"name"},[_vm._t("name",function(){return [_c('span',{attrs:{"title":_vm.name}},[_vm._v(_vm._s(_vm.name))])]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }